import {
  CLEAR_KEYWORD_SEARCH,
  CLEAR_SEARCH_RESULTS,
  GET_POPULAR_SEARCHES,
  GET_SEARCH_RESULTS,
  SET_KEYWORD_SEARCH,
  NOT_FOUND_SEARCH_RESULTS,
  SEARCH_ADD_BOOKMARK_LIVE,
  SEARCH_CLEAR_LIVE_MENU_OPTIONS,
  SET_LIVE_MENU_OPTIONS,
  IS_LOADING_SEARCH,
  POPULAR_ADD_BOOKMARK_LIVE,
  SET_ERROR_SEARCH,
} from '../constants';

const initialState = {
  notFoundResults: {
    status: false,
    type: '',
  },
  popular: [],
  contenidos: [],
  talentos: [],
  liveOptions: {
    isLiveFromSearcher: false,
    channel: undefined,
    event: undefined,
  },
  keyword: '',
  isLoading: false,
  errorSearch: [],
};

const searchResults = (state = initialState, action) => {
  switch (action.type) {
    case GET_SEARCH_RESULTS:
      return {
        ...state,
        contenidos: action?.payload?.searchResults,
        talentos: action?.payload?.talents?.external_talents
          ? action?.payload?.talents?.external_talents?.gracenote
          : [],
        notFoundResults: initialState.notFoundResults,
      };
    case GET_POPULAR_SEARCHES:
      return {
        ...state,
        popular: [...action.payload],
        notFoundResults: initialState.notFoundResults,
      };
    case NOT_FOUND_SEARCH_RESULTS:
      return {
        ...state,
        notFoundResults: action.payload,
        contenidos: [],
        talentos: [],
      };
    case CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        contenidos: initialState.contenidos,
        talentos: initialState.talentos,
      };
    case SEARCH_ADD_BOOKMARK_LIVE:
      return {
        ...state,
        contenidos: state.contenidos.map(item => {
          if (item.id === action.payload.id) {
            return { ...item, bookmark: action.payload.bookmark };
          }
          return item;
        }),
      };
    case POPULAR_ADD_BOOKMARK_LIVE:
      return {
        ...state,
        popular: state.popular?.map(item => {
          if (item?.id === action?.payload?.id) {
            return { ...item, bookmark: action?.payload?.bookmark };
          }
          return item;
        }),
      };
    case SET_LIVE_MENU_OPTIONS:
      return {
        ...state,
        liveOptions: { ...action.payload, isLiveFromSearcher: true },
      };
    case SEARCH_CLEAR_LIVE_MENU_OPTIONS:
      return {
        ...state,
        liveOptions: initialState.liveOptions,
      };
    case SET_KEYWORD_SEARCH:
      return {
        ...state,
        keyword: action.payload,
      };
    case CLEAR_KEYWORD_SEARCH:
      return {
        ...state,
        keyword: '',
      };
    case IS_LOADING_SEARCH:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_ERROR_SEARCH:
      return {
        ...state,
        errorSearch: action.payload,
      };
    default:
      return state;
  }
};

export default searchResults;
